import { Provider } from "@angular/core";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from "@angular/material/form-field";

/**
 * Outlined mat-form-fields, the base of the Order details "new UI" look
 * (colours/shape come from shared/styles/_new-ui-controls.scss).
 * Look only -- provide on a route or a dialog component.
 */
export const NEW_UI_FORM_FIELD_DEFAULTS: Provider = {
  provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
  useValue: { appearance: "outline", subscriptSizing: "dynamic" },
};
